export default {
    methods: {
        updateScenario(scenarioId, scenarioData) {
            return this.put(`/scenario/${scenarioId}`, scenarioData);
        },

        getScenario(scenarioId, expandIndicators = false) {
            let url = `/scenario/${scenarioId}`;

            if (expandIndicators) {
                url += '?expandIndicators';
            }

            return this.get(url);
        },

        getIndicatorsByScenario(scenarioId) {
            return this.get(`/scenario/${scenarioId}/indicators`);
        },

        publishScenario(scenarioId) {
            if (!scenarioId) {
                return Promise.reject(new Error('Scenario ID was empty'));
            }

            return this.put(`/scenario/${scenarioId}/publish`)
        },

        revertScenarioDraftChanges(scenarioId) {
            if (!scenarioId) {
                return Promise.reject(new Error('Scenario ID was empty'));
            }

            return this.put(`/scenario/${scenarioId}/revert-draft`)
        },

        clearScenario(scenarioId) {
            if (!scenarioId) {
                return Promise.reject(new Error('Scenario ID was empty'));
            }

            return this.put(`/scenario/${scenarioId}/clear`)
        }
    }
}